module.exports = __webpack_public_path__ + "static/img/footer.0f31768.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer.png
// module id = FBBW
// module chunks = 1